const FileAppender = function(url){

	let asyncEnabled  = false;

	let fileVersion = 1;

	let forceUpdate = false;

	let appendFunc = (type, callBack) =>{
		let file = null;

		if(forceUpdate === true){
			if(typeof url === "string" && url.indexOf("?") > 0){
				url += "&ver="+fileVersion;
			}else if(typeof url === "string"){
				url += "?ver="+fileVersion;
			}
			
		}

		if(type === "css"){
			file = document.createElement('link');
			file.type ='text/css';
			file.href = url;
			file.rel ='stylesheet';
			
		}else if(type === "js"){
			file = document.createElement('script');
			file.type = 'text/javascript';
			file.src = url;
			
		}


		if(file !== null){
			 file.onload = (req, resp) => {
			 	//console.warn("lalalal : ", req, resp);
			 	if(typeof callBack === "function"){
			 		callBack.apply(this, [resp]);
			 	}
			 }

			 file.onerror = (req, resp) => {
			 	alert("error");
			 }

			 document.getElementsByTagName('head')[0].appendChild(file);
		}

	}

	this.css = function(callBack){
		appendFunc("css", callBack);
	}
	this.js = function(callBack){
		appendFunc("js", callBack);
	}

	this.async = function(){
	    asyncEnabled = true;

	    return this;
	}

	this.addVersion = function(version){
		forceUpdate = true;

		if(!isNaN(version)){
			fileVersion = version;
		}else if(!isNaN(window.fileVersion)){
			fileVersion = window.fileVersion;
		}

		return this;
	}

};

export default FileAppender;


// WEBPACK FOOTER //
// ./src/util/FileAppender.js